enum CellValue {
  Unknown = -1,
  Empty = 0,
  Black = 1,
}

export default CellValue;
